import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveZoneFailed, saveZoneSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* saveZone(action) {
  try {
    const { id, data } = action.payload;
    const url = `${BACKEND_URL}/api/v1/zone/${id}`;
    const dataResponse = yield makeRequest(url, data, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(saveZoneSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(saveZoneFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(saveZoneFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
